
export const internalFundingList = [
  { _id: -1, display: "Avoir"},
  { _id: 0, display: "Payé"},
  { _id: 1, display: "A payer"},
]

export const externalFundingList = [
  { _id: 0, display: "Validé"},
  { _id: 1, display: "En attente"},
]
